var shippingRates = [
 {
  "Sr #": 14,
  "Province": "PUNJAB",
  "Booking\nCodes": "BPR",
  "CITY": "BHAIPHERU",
  "Air Curtain": 699,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 999,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 2399,
  "Twin Tub": 1699,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 45,
  "Province": "PUNJAB",
  "Booking\nCodes": "FSD",
  "CITY": "FAISALABAD",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 58,
  "Province": "PUNJAB",
  "Booking\nCodes": "GUJ",
  "CITY": "GUJRANWALA",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 59,
  "Province": "PUNJAB",
  "Booking\nCodes": "GRT",
  "CITY": "GUJRAT",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 74,
  "Province": "PUNJAB",
  "Booking\nCodes": "ISB",
  "CITY": "ISLAMABAD",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 83,
  "Province": "PUNJAB",
  "Booking\nCodes": "JLM",
  "CITY": "JHELUM",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 98,
  "Province": "PUNJAB",
  "Booking\nCodes": "KSR",
  "CITY": "KASUR",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 121,
  "Province": "PUNJAB",
  "Booking\nCodes": "LHE",
  "CITY": "LAHORE",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5499,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 149,
  "Province": "PUNJAB",
  "Booking\nCodes": "MUX",
  "CITY": "MULTAN",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 150,
  "Province": "PUNJAB",
  "Booking\nCodes": "MRY",
  "CITY": "MURIDKE",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 160,
  "Province": "PUNJAB",
  "Booking\nCodes": "OKA",
  "CITY": "OKARA",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 164,
  "Province": "PUNJAB",
  "Booking\nCodes": "PTI",
  "CITY": "PATTOKI",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 178,
  "Province": "PUNJAB",
  "Booking\nCodes": "RND",
  "CITY": "RAIWIND",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 999,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 2399,
  "Twin Tub": 1699,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 182,
  "Province": "PUNJAB",
  "Booking\nCodes": "RWP",
  "CITY": "RAWALPINDI",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 187,
  "Province": "PUNJAB",
  "Booking\nCodes": "SWL",
  "CITY": "SAHIWAL",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 194,
  "Province": "PUNJAB",
  "Booking\nCodes": "SGD",
  "CITY": "SARGODHA",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 201,
  "Province": "PUNJAB",
  "Booking\nCodes": "SRA",
  "CITY": "SHEIKHUPURA",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 205,
  "Province": "PUNJAB",
  "Booking\nCodes": "SLT",
  "CITY": "SIALKOT",
  "Air Curtain": 599,
  "Automatic Front Load": 2499,
  "Automatic Top Load": 2499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 1899,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 1899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2499,
  "Cooking Range (Cabinet)": 2499,
  "Deep Freezer": 2999,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 1899,
  "Double Door - Direct Cool": 3899,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2399,
  "Electric Water Cooler": 2399,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 3899,
  "Food Processor": 699,
  "French Door (4-Door)": 5399,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 1899,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1199,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 1999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1699,
  "LED Television": 1799,
  "Local Air Cooler": 1999,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 1999,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1199,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5399,
  "Single Tub": 1899,
  "Sound Bar": 1199,
  "Spinner": 1499,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4499,
  "Twin Storage Tank (Electric & Gass)": 1999,
  "Twin Tub": 1699,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3199,
  "Water Dispenser": 999,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 1,
  "Province": "KPK",
  "Booking\nCodes": "ABT",
  "CITY": "ABBOTABAD ",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 799,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 6,
  "Province": "PUNJAB",
  "Booking\nCodes": "ARF",
  "CITY": "ARIFWALA",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 7,
  "Province": "PUNJAB",
  "Booking\nCodes": "ATT",
  "CITY": "ATTOCK",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 9,
  "Province": "PUNJAB",
  "Booking\nCodes": "NGR",
  "CITY": "BAHAWALNAGAR",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 10,
  "Province": "PUNJAB",
  "Booking\nCodes": "BHV",
  "CITY": "BAHAWALPUR",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 699,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 22,
  "Province": "PUNJAB",
  "Booking\nCodes": "BRW",
  "CITY": "BUREWALA",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 24,
  "Province": "PUNJAB",
  "Booking\nCodes": "CKL",
  "CITY": "CHAKWAL",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 27,
  "Province": "PUNJAB",
  "Booking\nCodes": "CCW",
  "CITY": "CHICHAWATNI",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 28,
  "Province": "PUNJAB",
  "Booking\nCodes": "IOT",
  "CITY": "CHINIOT",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 33,
  "Province": "PUNJAB",
  "Booking\nCodes": "DKA",
  "CITY": "DASKA",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 37,
  "Province": "PUNJAB",
  "Booking\nCodes": "DGK",
  "CITY": "DERA GHAZI KHAN",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 55,
  "Province": "PUNJAB",
  "Booking\nCodes": "GRA",
  "CITY": "GOJRA",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 61,
  "Province": "PUNJAB",
  "Booking\nCodes": "HFZ",
  "CITY": "HAFIZABAD",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 72,
  "Province": "SINDH",
  "Booking\nCodes": "HDD",
  "CITY": "HYDERABAD",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 80,
  "Province": "PUNJAB",
  "Booking\nCodes": "JRW",
  "CITY": "JARANWALA",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 82,
  "Province": "PUNJAB",
  "Booking\nCodes": "JHG",
  "CITY": "JHANG",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 91,
  "Province": "PUNJAB",
  "Booking\nCodes": "KMK",
  "CITY": "KAMOKE",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 699,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 95,
  "Province": "SINDH",
  "Booking\nCodes": "KHI",
  "CITY": "KARACHI",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 107,
  "Province": "PUNJAB",
  "Booking\nCodes": "KWL",
  "CITY": "KHANEWAL",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 699,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 108,
  "Province": "PUNJAB",
  "Booking\nCodes": "KRN",
  "CITY": "KHARIAN",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 122,
  "Province": "PUNJAB",
  "Booking\nCodes": "LLM",
  "CITY": "LALA MUSA",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 126,
  "Province": "PUNJAB",
  "Booking\nCodes": "LOD",
  "CITY": "LODHRAN",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 131,
  "Province": "PUNJAB",
  "Booking\nCodes": "MBD",
  "CITY": "MANDI BAHAUDDIN",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 139,
  "Province": "PUNJAB",
  "Booking\nCodes": "MCN",
  "CITY": "MIAN CHUNNU",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 154,
  "Province": "PUNJAB",
  "Booking\nCodes": "NRL",
  "CITY": "NAROWAL",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 699,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 158,
  "Province": "KPK",
  "Booking\nCodes": "NOW",
  "CITY": "NOWSHERA",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 799,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 161,
  "Province": "PUNJAB",
  "Booking\nCodes": "PPS",
  "CITY": "PAKPATTAN",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 166,
  "Province": "KPK",
  "Booking\nCodes": "PEW",
  "CITY": "PESHAWAR",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 799,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 177,
  "Province": "PUNJAB",
  "Booking\nCodes": "RYK",
  "CITY": "RAHIM YAR KHAN",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 499,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 899,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 699,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 599,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 599,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 699,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 999,
  "Gas Room Heater": 699,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 999,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 499,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 499,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 185,
  "Province": "PUNJAB",
  "Booking\nCodes": "SQD",
  "CITY": "SADIQABAD",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 190,
  "Province": "PUNJAB",
  "Booking\nCodes": "SMD",
  "CITY": "SAMUNDRI",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 207,
  "Province": "PUNJAB",
  "Booking\nCodes": "SAG",
  "CITY": "SRAI ALAMGIR",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 208,
  "Province": "SINDH",
  "Booking\nCodes": "SKZ",
  "CITY": "SUKKUR",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 226,
  "Province": "PUNJAB",
  "Booking\nCodes": "VRI",
  "CITY": "VEHARI",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 227,
  "Province": "Punjab",
  "Booking\nCodes": "WAH",
  "CITY": "WAH CANT",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 228,
  "Province": "PUNJAB",
  "Booking\nCodes": "WAZ",
  "CITY": "WAZIRABAD",
  "Air Curtain": 650,
  "Automatic Front Load": 2799,
  "Automatic Top Load": 2899,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2499,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3499,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2199,
  "Double Door - Direct Cool": 4299,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2499,
  "Electric Water Cooler": 2499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 999,
  "Floor Standing Cabinet": 4099,
  "Food Processor": 999,
  "French Door (4-Door)": 5899,
  "Gadgets": 499,
  "Games": 999,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1299,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 999,
  "Inverter Air Condtioner": 2499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 1999,
  "LED Television": 2499,
  "Local Air Cooler": 2499,
  "Meat Mincer": 799,
  "Microwave Oven": 999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2499,
  "Oven Toaster": 999,
  "PANINI GRILL": 499,
  "Party Box": 1299,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 5999,
  "Single Tub": 2499,
  "Sound Bar": 1599,
  "Spinner": 1799,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 4999,
  "Twin Storage Tank (Electric & Gass)": 2499,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 3999,
  "Water Dispenser": 1399,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 3,
  "Province": "PUNJAB",
  "Booking\nCodes": "APE",
  "CITY": "AHMED PUR EAST",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 25,
  "Province": "KPK",
  "Booking\nCodes": "CHD",
  "CITY": "CHARSADA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 499,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 499,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 599,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 599,
  "Toaster": 499,
  "Tooth Brush": 499,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 999
 },
 {
  "Sr #": 29,
  "Province": "PUNJAB",
  "Booking\nCodes": "CHS",
  "CITY": "CHISHTIAN",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 35,
  "Province": "SINDH",
  "Booking\nCodes": "DKI",
  "CITY": "DEHARKI",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 36,
  "Province": "PUNJAB",
  "Booking\nCodes": "DPR",
  "CITY": "DEPALPUR",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 38,
  "Province": "KPK",
  "Booking\nCodes": "DIK",
  "CITY": "DERA ISMAIL KHAN",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 799,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 899,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 41,
  "Province": "PUNJAB",
  "Booking\nCodes": "DIN",
  "CITY": "DINA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 53,
  "Province": "PUNJAB",
  "Booking\nCodes": "GKR",
  "CITY": "GHAKKAR",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 57,
  "Province": "PUNJAB",
  "Booking\nCodes": "GKN",
  "CITY": "GUJAR KHAN",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 64,
  "Province": "KPK",
  "Booking\nCodes": "HRI",
  "CITY": "HARIPUR",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 67,
  "Province": "PUNJAB",
  "Booking\nCodes": "HSL",
  "CITY": "HASIL PUR",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 68,
  "Province": "KPK",
  "Booking\nCodes": "HTR",
  "CITY": "HATTAR",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 73,
  "Province": "PUNJAB",
  "Booking\nCodes": "IBD",
  "CITY": "ILLAH ABAD",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 79,
  "Province": "SINDH",
  "Booking\nCodes": "JSR",
  "CITY": "JAMSHORO",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 81,
  "Province": "PUNJAB",
  "Booking\nCodes": "JHN",
  "CITY": "JEHANIAN",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 84,
  "Province": "PUNJAB",
  "Booking\nCodes": "JRD",
  "CITY": "JOHARABAD",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 85,
  "Province": "PUNJAB",
  "Booking\nCodes": "KBR",
  "CITY": "KABIRWALA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 89,
  "Province": "PUNJAB",
  "Booking\nCodes": "KML",
  "CITY": "KAMALIA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 92,
  "Province": "PUNJAB",
  "Booking\nCodes": "KMA",
  "CITY": "KAMRA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 110,
  "Province": "PUNJAB",
  "Booking\nCodes": "KRW",
  "CITY": "KHURIANWALA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 111,
  "Province": "PUNJAB",
  "Booking\nCodes": "KHB",
  "CITY": "KHUSHAB",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 112,
  "Province": "KPK",
  "Booking\nCodes": "OHT",
  "CITY": "KOHAT",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 127,
  "Province": "PUNJAB",
  "Booking\nCodes": "MLS",
  "CITY": "MAILSI",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 134,
  "Province": "KPK",
  "Booking\nCodes": "MNA",
  "CITY": "MANSEHRA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 135,
  "Province": "KPK",
  "Booking\nCodes": "MRD",
  "CITY": "MARDAN",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 140,
  "Province": "PUNJAB",
  "Booking\nCodes": "MWI",
  "CITY": "MIANWALI",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 143,
  "Province": "AJK",
  "Booking\nCodes": "MRP",
  "CITY": "MIRPUR (AK)",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 145,
  "Province": "SINDH",
  "Booking\nCodes": "MPK",
  "CITY": "MIRPURKHAS",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 148,
  "Province": "SINDH",
  "Booking\nCodes": "MRO",
  "CITY": "MORO",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 152,
  "Province": "PUNJAB",
  "Booking\nCodes": "MZG",
  "CITY": "MUZAFFARGARH",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 155,
  "Province": "SINDH",
  "Booking\nCodes": "WNS",
  "CITY": "NAWABSHAH",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 157,
  "Province": "PUNJAB",
  "Booking\nCodes": "NVK",
  "CITY": "NOWSHEHRA VERKA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 162,
  "Province": "SINDH",
  "Booking\nCodes": "PNQ",
  "CITY": "PANO AQIL",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 163,
  "Province": "PUNJAB",
  "Booking\nCodes": "PSR",
  "CITY": "PASROOR",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 174,
  "Province": "PUNJAB",
  "Booking\nCodes": "QDS",
  "CITY": "QILA DILDAR SINGH",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 184,
  "Province": "SINDH",
  "Booking\nCodes": "RHI",
  "CITY": "ROHRI",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 192,
  "Province": "PUNJAB",
  "Booking\nCodes": "SGH",
  "CITY": "SANGLA HILL",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 195,
  "Province": "KPK",
  "Booking\nCodes": "SWT",
  "CITY": "SAWAT",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 196,
  "Province": "PUNJAB",
  "Booking\nCodes": "SHT",
  "CITY": "SHAH KOT",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 200,
  "Province": "PUNJAB",
  "Booking\nCodes": "SQR",
  "CITY": "SHARAQ PUR",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 210,
  "Province": "SINDH",
  "Booking\nCodes": "TMK",
  "CITY": "TANDO MUHAMMAD KHAN",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 1199,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 999,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 221,
  "Province": "PUNJAB",
  "Booking\nCodes": "TXL",
  "CITY": "TEXILA",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 223,
  "Province": "PUNJAB",
  "Booking\nCodes": "TTS",
  "CITY": "TOBA TEK SINGH",
  "Air Curtain": 699,
  "Automatic Front Load": 2999,
  "Automatic Top Load": 2999,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 2999,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2899,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3499,
  "Cassete (Ceiling)": 3499,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 2999,
  "Cooking Range (Cabinet)": 2999,
  "Deep Freezer": 3999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2499,
  "Double Door - Direct Cool": 4699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 2999,
  "Electric Water Cooler": 2999,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1099,
  "Floor Standing Cabinet": 4499,
  "Food Processor": 999,
  "French Door (4-Door)": 6499,
  "Gadgets": 499,
  "Games": 1099,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 2999,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1499,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1099,
  "Inverter Air Condtioner": 2999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1299,
  "Kitchen Hood": 2499,
  "LED Television": 2799,
  "Local Air Cooler": 2999,
  "Meat Mincer": 799,
  "Microwave Oven": 1299,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 2999,
  "Oven Toaster": 1299,
  "PANINI GRILL": 499,
  "Party Box": 1499,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 6499,
  "Single Tub": 2799,
  "Sound Bar": 1599,
  "Spinner": 1999,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 5399,
  "Twin Storage Tank (Electric & Gass)": 2999,
  "Twin Tub": 2499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4299,
  "Water Dispenser": 1599,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 2,
  "Province": "PUNJAB",
  "Booking\nCodes": "AKM",
  "CITY": "ABDUL HAKIM",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 4,
  "Province": "PUNJAB",
  "Booking\nCodes": "APC",
  "CITY": "ALI PURCHATAH",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 5,
  "Province": "PUNJAB",
  "Booking\nCodes": "AIP",
  "CITY": "ALIPUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 8,
  "Province": "SINDH",
  "Booking\nCodes": "BDN",
  "CITY": "BADIN",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 11,
  "Province": "KPK",
  "Booking\nCodes": "BNU",
  "CITY": "BANNU",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 12,
  "Province": "PUNJAB",
  "Booking\nCodes": "BSR",
  "CITY": "BASIRPUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 13,
  "Province": "PUNJAB",
  "Booking\nCodes": "BST",
  "CITY": "BASTI MALOOK",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 15,
  "Province": "PUNJAB",
  "Booking\nCodes": "BKK",
  "CITY": "BHAKKAR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 16,
  "Province": "PUNJAB",
  "Booking\nCodes": "BWL",
  "CITY": "BHALWAL",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 17,
  "Province": "SINDH",
  "Booking\nCodes": "SDA",
  "CITY": "BHAN SAEEDABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 18,
  "Province": "PUNJAB",
  "Booking\nCodes": "BWA",
  "CITY": "BHAWANA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 19,
  "Province": "PUNJAB",
  "Booking\nCodes": "BRA",
  "CITY": "BHERA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 23,
  "Province": "PUNJAB",
  "Booking\nCodes": "CKJ",
  "CITY": "CHAK JHUMRA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 30,
  "Province": "PUNJAB",
  "Booking\nCodes": "CAZ",
  "CITY": "CHOWK AZAM",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 31,
  "Province": "PUNJAB",
  "Booking\nCodes": "CHN",
  "CITY": "CHUNIAN",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 32,
  "Province": "SINDH",
  "Booking\nCodes": "DDU",
  "CITY": "DADU",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 34,
  "Province": "PUNJAB",
  "Booking\nCodes": "DTA",
  "CITY": "DAULTALA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 40,
  "Province": "PUNJAB",
  "Booking\nCodes": "DJK",
  "CITY": "DIJKOT",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 42,
  "Province": "PUNJAB",
  "Booking\nCodes": "DNG",
  "CITY": "DINGA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 47,
  "Province": "PUNJAB",
  "Booking\nCodes": "FQD",
  "CITY": "FAROQABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 48,
  "Province": "PUNJAB",
  "Booking\nCodes": "FPR",
  "CITY": "FATEHPUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 49,
  "Province": "PUNJAB",
  "Booking\nCodes": "FRW",
  "CITY": "FEROZE WATWAN",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 50,
  "Province": "PUNJAB",
  "Booking\nCodes": "FAB",
  "CITY": "FORT ABBAS",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 51,
  "Province": "SINDH",
  "Booking\nCodes": "GBT",
  "CITY": "GAMBAT",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 54,
  "Province": "SINDH",
  "Booking\nCodes": "GTI",
  "CITY": "GHOTKI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 56,
  "Province": "SINDH",
  "Booking\nCodes": "GDU",
  "CITY": "GUDDU",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 60,
  "Province": "PUNJAB",
  "Booking\nCodes": "HBD",
  "CITY": "HABIBABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 62,
  "Province": "SINDH",
  "Booking\nCodes": "HLA",
  "CITY": "HALA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 65,
  "Province": "PUNJAB",
  "Booking\nCodes": "HRN",
  "CITY": "HAROONABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 66,
  "Province": "KPK",
  "Booking\nCodes": "HSN",
  "CITY": "HASANABDAL",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 69,
  "Province": "PUNJAB",
  "Booking\nCodes": "HLK",
  "CITY": "HAVELI LAKHA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 71,
  "Province": "PUNJAB",
  "Booking\nCodes": "HSM",
  "CITY": "HUJRA SHAH MUQEEM",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 75,
  "Province": "SINDH",
  "Booking\nCodes": "JCB",
  "CITY": "JACOBABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 76,
  "Province": "PUNJAB",
  "Booking\nCodes": "JPJ",
  "CITY": "JALAL PUR JATTA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 77,
  "Province": "PUNJAB",
  "Booking\nCodes": "JPW",
  "CITY": "JALAL PUR PIRWALA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 93,
  "Province": "SINDH",
  "Booking\nCodes": "KKT",
  "CITY": "KANDH KOT",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 94,
  "Province": "SINDH",
  "Booking\nCodes": "KDR",
  "CITY": "KANDIARO",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 96,
  "Province": "SINDH",
  "Booking\nCodes": "KHM",
  "CITY": "KASHMORE",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 97,
  "Province": "PUNJAB",
  "Booking\nCodes": "KSW",
  "CITY": "KASOWAL",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 100,
  "Province": "SINDH",
  "Booking\nCodes": "KPM",
  "CITY": "KHAIR PUR MEERUS",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 101,
  "Province": "SINDH",
  "Booking\nCodes": "KHP",
  "CITY": "KHAIRPUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 104,
  "Province": "PUNJAB",
  "Booking\nCodes": "KGH",
  "CITY": "KHAN GARH",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 105,
  "Province": "PUNJAB",
  "Booking\nCodes": "KKD",
  "CITY": "KHAN KA DOGRAN",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 106,
  "Province": "SINDH",
  "Booking\nCodes": "KNP",
  "CITY": "KHAN PUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 109,
  "Province": "PUNJAB",
  "Booking\nCodes": "KDA",
  "CITY": "KHIDERWALA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 113,
  "Province": "PUNJAB",
  "Booking\nCodes": "KDU",
  "CITY": "KOT ADDU",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 116,
  "Province": "PUNJAB",
  "Booking\nCodes": "KRK",
  "CITY": "KOT RADHA KISHAN",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 117,
  "Province": "AJK",
  "Booking\nCodes": "KOL",
  "CITY": "KOTLI (A.K)",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 118,
  "Province": "SINDH",
  "Booking\nCodes": "KTR",
  "CITY": "KOTRI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 120,
  "Province": "SINDH",
  "Booking\nCodes": "KNI",
  "CITY": "KUNRI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 123,
  "Province": "SINDH",
  "Booking\nCodes": "LAR",
  "CITY": "LARKANA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 124,
  "Province": "PUNJAB",
  "Booking\nCodes": "LYY",
  "CITY": "LAYYAH",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 125,
  "Province": "PUNJAB",
  "Booking\nCodes": "LQR",
  "CITY": "LIAQATPUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 128,
  "Province": "KPK",
  "Booking\nCodes": "MKD",
  "CITY": "MALAKAND",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 129,
  "Province": "PUNJAB",
  "Booking\nCodes": "MKW",
  "CITY": "MALIK WAL",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 130,
  "Province": "PUNJAB",
  "Booking\nCodes": "MWA",
  "CITY": "MANA WALA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 133,
  "Province": "PUNJAB",
  "Booking\nCodes": "MMD",
  "CITY": "MANGA MANDI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 136,
  "Province": "SINDH",
  "Booking\nCodes": "MTL",
  "CITY": "MATLI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 137,
  "Province": "SINDH",
  "Booking\nCodes": "MHR",
  "CITY": "MEHAR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 138,
  "Province": "SINDH",
  "Booking\nCodes": "MBP",
  "CITY": "MEHRAB PUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 142,
  "Province": "KPK",
  "Booking\nCodes": "MIN",
  "CITY": "MINGORA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 144,
  "Province": "SINDH",
  "Booking\nCodes": "MPM",
  "CITY": "MIRPUR MATHELO",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 146,
  "Province": "SINDH",
  "Booking\nCodes": "MTI",
  "CITY": "MITIARI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 147,
  "Province": "PUNJAB",
  "Booking\nCodes": "MAB",
  "CITY": "MORE AIMANABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 151,
  "Province": "AJK",
  "Booking\nCodes": "MAK",
  "CITY": "MUZAFARABAD (A.K)",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 153,
  "Province": "PUNJAB",
  "Booking\nCodes": "NKS",
  "CITY": "NANKANA SAHAB",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 159,
  "Province": "SINDH",
  "Booking\nCodes": "NFZ",
  "CITY": "NOWSHERO FEROZ",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 167,
  "Province": "PUNJAB",
  "Booking\nCodes": "PHL",
  "CITY": "PHALIA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 168,
  "Province": "PUNJAB",
  "Booking\nCodes": "BPR",
  "CITY": "PHOOL NAGAR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 169,
  "Province": "PUNJAB",
  "Booking\nCodes": "PDK",
  "CITY": "PIND DADAN KHAN",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 171,
  "Province": "PUNJAB",
  "Booking\nCodes": "PML",
  "CITY": "PIRMAHAL",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 175,
  "Province": "BALUCHISTAN",
  "Booking\nCodes": "UET",
  "CITY": "QUETTA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 176,
  "Province": "PUNJAB",
  "Booking\nCodes": "RBW",
  "CITY": "RABWAH",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 179,
  "Province": "PUNJAB",
  "Booking\nCodes": "RJP",
  "CITY": "RAJAN PUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 183,
  "Province": "PUNJAB",
  "Booking\nCodes": "RLK",
  "CITY": "RENALA KHURD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 186,
  "Province": "PUNJAB",
  "Booking\nCodes": "SFD",
  "CITY": "SAFDARABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 188,
  "Province": "SINDH",
  "Booking\nCodes": "SKR",
  "CITY": "SAKRAND",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 189,
  "Province": "PUNJAB",
  "Booking\nCodes": "SMB",
  "CITY": "SAMBRIAL",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 191,
  "Province": "SINDH",
  "Booking\nCodes": "SAN",
  "CITY": "SANGHAR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 197,
  "Province": "SINDH",
  "Booking\nCodes": "SHH",
  "CITY": "SHAHDADKOT",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 198,
  "Province": "SINDH",
  "Booking\nCodes": "SPR",
  "CITY": "SHAHDADPUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 199,
  "Province": "PUNJAB",
  "Booking\nCodes": "SGR",
  "CITY": "SHAKARGARH",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 202,
  "Province": "SINDH",
  "Booking\nCodes": "SHP",
  "CITY": "SHIKARPUR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 203,
  "Province": "PUNJAB",
  "Booking\nCodes": "SHK",
  "CITY": "SHOR KOT",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 204,
  "Province": "PUNJAB",
  "Booking\nCodes": "SHJ",
  "CITY": "SHUJAABAD",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 209,
  "Province": "KPK",
  "Booking\nCodes": "SWB",
  "CITY": "SWABI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 211,
  "Province": "KPK",
  "Booking\nCodes": "TBH",
  "CITY": "TAKHTBAI",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 212,
  "Province": "PUNJAB",
  "Booking\nCodes": "TLG",
  "CITY": "TALAGANG",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 215,
  "Province": "PUNJAB",
  "Booking\nCodes": "TWA",
  "CITY": "TANDLIAN WALA",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 999,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 799,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 216,
  "Province": "SINDH",
  "Booking\nCodes": "TDO",
  "CITY": "TANDO ADAM",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 217,
  "Province": "SINDH",
  "Booking\nCodes": "TAY",
  "CITY": "TANDO ALLAH YAR",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 218,
  "Province": "SINDH",
  "Booking\nCodes": "TDA",
  "CITY": "TANDO JAM",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 222,
  "Province": "KPK",
  "Booking\nCodes": "TMG",
  "CITY": "TIMERGARAH",
  "Air Curtain": 899,
  "Automatic Front Load": 3499,
  "Automatic Top Load": 3499,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 3499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 2999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 3999,
  "Cassete (Ceiling)": 3999,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 3399,
  "Cooking Range (Cabinet)": 3399,
  "Deep Freezer": 5999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 2999,
  "Double Door - Direct Cool": 6699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 3499,
  "Electric Water Cooler": 3499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1299,
  "Floor Standing Cabinet": 5999,
  "Food Processor": 1199,
  "French Door (4-Door)": 9199,
  "Gadgets": 499,
  "Games": 1299,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 3499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 1799,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1299,
  "Inverter Air Condtioner": 3499,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 1599,
  "Kitchen Hood": 2999,
  "LED Television": 2999,
  "Local Air Cooler": 3499,
  "Meat Mincer": 999,
  "Microwave Oven": 1499,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 3499,
  "Oven Toaster": 1499,
  "PANINI GRILL": 499,
  "Party Box": 1799,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 9299,
  "Single Tub": 2999,
  "Sound Bar": 1999,
  "Spinner": 2499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 7699,
  "Twin Storage Tank (Electric & Gass)": 3499,
  "Twin Tub": 3199,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 4999,
  "Water Dispenser": 1999,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 20,
  "Province": "SINDH",
  "Booking\nCodes": "BHT",
  "CITY": "BHET SHAH",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 21,
  "Province": "AJK",
  "Booking\nCodes": "BMB",
  "CITY": "BHIMBER",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 26,
  "Province": "PUNJAB",
  "Booking\nCodes": "CWD",
  "CITY": "CHAWINDA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 39,
  "Province": "SINDH",
  "Booking\nCodes": "DIG",
  "CITY": "DIGRI",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 43,
  "Province": "PUNJAB",
  "Booking\nCodes": "DBN",
  "CITY": "DONGA BONGA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 44,
  "Province": "PUNJAB",
  "Booking\nCodes": "DNR",
  "CITY": "DUNYA PUR",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 46,
  "Province": "PUNJAB",
  "Booking\nCodes": "FQR",
  "CITY": "FAQIRWALI",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 52,
  "Province": "SINDH",
  "Booking\nCodes": "GSN",
  "CITY": "GARHI YASIN",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 63,
  "Province": "PUNJAB",
  "Booking\nCodes": "HPA",
  "CITY": "HARAPPA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 70,
  "Province": "PUNJAB",
  "Booking\nCodes": "HMA",
  "CITY": "HEAD MARALA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 78,
  "Province": "PUNJAB",
  "Booking\nCodes": "JMP",
  "CITY": "JAMPUR",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 86,
  "Province": "PUNJAB",
  "Booking\nCodes": "KLE",
  "CITY": "KAHROR LAL ESAN",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 87,
  "Province": "PUNJAB",
  "Booking\nCodes": "KPC",
  "CITY": "KAHROR PAKKA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 88,
  "Province": "PUNJAB",
  "Booking\nCodes": "KBH",
  "CITY": "KALA BAGH",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 90,
  "Province": "SINDH",
  "Booking\nCodes": "KAK",
  "CITY": "KAMBER ALI KHAN",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 99,
  "Province": "KPK",
  "Booking\nCodes": "KTL",
  "CITY": "KATLANG",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 102,
  "Province": "SINDH",
  "Booking\nCodes": "KNS",
  "CITY": "KHAIRPUR NATHAN SHAH",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 103,
  "Province": "PUNJAB",
  "Booking\nCodes": "KBL",
  "CITY": "KHAN BELA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 114,
  "Province": "PUNJAB",
  "Booking\nCodes": "KOM",
  "CITY": "KOT MITHAN",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 115,
  "Province": "PUNJAB",
  "Booking\nCodes": "KMN",
  "CITY": "KOT MOMIN",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3999,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 119,
  "Province": "PUNJAB",
  "Booking\nCodes": "KUN",
  "CITY": "KUNDIAN",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 132,
  "Province": "PUNJAB",
  "Booking\nCodes": "MSG",
  "CITY": "MANDI SADIQ GUNJ",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 141,
  "Province": "PUNJAB",
  "Booking\nCodes": "MHD",
  "CITY": "MINCHINABAD",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 156,
  "Province": "SINDH",
  "Booking\nCodes": "NSA",
  "CITY": "NEW SAEEDAABD",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 165,
  "Province": "SINDH",
  "Booking\nCodes": "PJH",
  "CITY": "PEER JO GOTH",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 170,
  "Province": "PUNJAB",
  "Booking\nCodes": "PPL",
  "CITY": "PIPLAN",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 172,
  "Province": "SINDH",
  "Booking\nCodes": "QMB",
  "CITY": "QAMBER",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 173,
  "Province": "SINDH",
  "Booking\nCodes": "QAM",
  "CITY": "QAZI AHMED",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 180,
  "Province": "SINDH",
  "Booking\nCodes": "RNI",
  "CITY": "RANI PUR",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 181,
  "Province": "SINDH",
  "Booking\nCodes": "RTD",
  "CITY": "RATO DERO ",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 193,
  "Province": "KPK",
  "Booking\nCodes": "SNG",
  "CITY": "SARAI NORANG",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 206,
  "Province": "PUNJAB",
  "Booking\nCodes": "SWA",
  "CITY": "SOHAWA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 213,
  "Province": "PUNJAB",
  "Booking\nCodes": "TMB",
  "CITY": "TALAMBA",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 214,
  "Province": "PUNJAB",
  "Booking\nCodes": "TWD",
  "CITY": "TALWANDI",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 219,
  "Province": "KPK",
  "Booking\nCodes": "TNK",
  "CITY": "TANK",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 220,
  "Province": "PUNJAB",
  "Booking\nCodes": "TSF",
  "CITY": "TAUNSA SHARIF",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 224,
  "Province": "PUNJAB",
  "Booking\nCodes": "UCH",
  "CITY": "UCH SHARIF",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 },
 {
  "Sr #": 225,
  "Province": "SINDH",
  "Booking\nCodes": "UKT",
  "CITY": "UMER KOT",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 799,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1199,
  "Controller": 799,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 999,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 799,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 799,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 1199,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1499,
  "Gas Room Heater": 999,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1499,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 999,
  "Juicer \/ Blender \/ Grinder": 499,
  "Kitchen Hob": 2499,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 999,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 1199,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 1199,
  "Toaster": 1199,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 1299,
  "Vacume Cleaner": 1499,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1499
 },
 {
  "Sr #": 229,
  "Province": "PUNJAB",
  "Booking\nCodes": "ZFW",
  "CITY": "ZAFARWAL",
  "Air Curtain": 1499,
  "Automatic Front Load": 5099,
  "Automatic Top Load": 5399,
  "Battery \/ Charger": 299,
  "Bed Room Refrigerator": 5499,
  "Blender": 499,
  "Blender \/ Grinder": 499,
  "Bracket \/ Speaker Stand": 399,
  "Built in Oven": 3999,
  "COVER": 299,
  "Cables": 299,
  "Cassete (Ceiling Exposed)": 7599,
  "Cassete (Ceiling)": 7599,
  "Chef Machine": 599,
  "Choper": 699,
  "Circuit Breaker": 299,
  "Citress Press": 499,
  "Coffee Maker": 999,
  "Console": 1099,
  "Controller": 699,
  "Cooking Range": 6399,
  "Cooking Range (Cabinet)": 6399,
  "Deep Freezer": 7999,
  "Deep Fryer \/ Air Fryer": 799,
  "Dish Washer": 5299,
  "Double Door - Direct Cool": 12699,
  "Dry Iron": 699,
  "Electric Halogen Heater": 499,
  "Electric Kettle": 599,
  "Electric Room Dish Heater": 699,
  "Electric Storage Tank": 5499,
  "Electric Water Cooler": 5499,
  "Fan Heater": 599,
  "Fast Electric Water Heater": 1899,
  "Floor Standing Cabinet": 9999,
  "Food Processor": 999,
  "French Door (4-Door)": 17499,
  "Gadgets": 499,
  "Games": 1899,
  "Garment Steamer": 1299,
  "Gas Room Heater": 799,
  "Gas Water Heater Storage Tank": 5499,
  "Hair Dryer": 599,
  "Hair Straightener": 599,
  "Hand Mixer \/ Blender": 599,
  "Home Theatre": 2999,
  "Hot Plate": 999,
  "ICE MAKER": 1299,
  "Insect Killer": 499,
  "Instant Water Heater (Gas)": 1899,
  "Inverter Air Condtioner": 4999,
  "Juicer": 799,
  "Juicer \/ Blender \/ Grinder": 299,
  "Kitchen Hob": 1999,
  "Kitchen Hood": 3799,
  "LED Television": 3499,
  "Local Air Cooler": 3999,
  "Meat Mincer": 799,
  "Microwave Oven": 1999,
  "Mobile \/ Simple Telephone": 999,
  "Non Inverter Air Conditioner": 4999,
  "Oven Toaster": 1999,
  "PANINI GRILL": 499,
  "Party Box": 2999,
  "Pizza Maker": 999,
  "Portable Speaker": 599,
  "Protector": 499,
  "Refrigerator Stand": 499,
  "Remote": 399,
  "Rice Cooker": 999,
  "Roti Maker": 599,
  "Sandwich Maker": 599,
  "Shaver \/ Trimmer": 599,
  "Side x Side Refrigerator": 17499,
  "Single Tub": 4799,
  "Sound Bar": 2499,
  "Spinner": 3499,
  "Stablizer": 599,
  "Steam Iron": 999,
  "Toaster": 999,
  "Tooth Brush": 299,
  "Top Mount - No Frost": 14599,
  "Twin Storage Tank (Electric & Gass)": 5499,
  "Twin Tub": 3499,
  "UPS": 999,
  "Vacume Cleaner": 1299,
  "Vertical Freezer": 6999,
  "Water Dispenser": 2499,
  "Water Filter \/ Air Purifier": 1299
 }
]